import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface Logo {
  src: string;
  alt: string;
}
const logos: Logo[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/jqubZ49fSWEo33GuxgeMAw/007.jpg.webp',
  alt: 'CertainTeed Master Shingle Applicator'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wQC79DBgxpt1cdHLDV3CkS/Owens-Corning-Platinum-Preferred-Contractors.webp',
  alt: 'Owens Corning Platinum Preferred Contractor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cJebNPK1skDoJZKe6KTRsN/Roofing-Contractors-Association-of-Texas.webp',
  alt: 'RCAT Roofing Contractors Association of Texas Licensed Contractor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tRVWP9ePzozd65VHB3fLFh/North-Texas-Roofing-Contractors-Association-1-1.webp',
  alt: 'North Texas Roofing Contractors Association'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4Hw6UW67pyQ8L8Ju9dy7GG/ftylhe3ta1og1.webp',
  alt: 'Trusted Roofer Verified Business'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/riStZ2ExSMp1nsibtTEnW4/online-Atlas-PRO-Platinum-Select-1.webp',
  alt: 'Atlas Pro Plus Platinum Select Contractor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1xQySXJTrXYbmMUn8j2nQE/toprated-solid-border.webp',
  alt: 'HomeAdvisor Top Rated'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pLTgw7GBTyfeNPzAk4bVnL/Google-Verified-Business.webp',
  alt: 'Google Verified Business'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fCJC2QjGcpJsdQbTJSUHFG/Better-Business-Bureau-1.webp',
  alt: 'BBB A Plus Accredited Business'
}];
export function Accreditations() {
  // Duplicate the list so the marquee can loop seamlessly.
  const track = [...logos, ...logos];
  return <section className="bg-white py-14 lg:py-20" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <p className="text-center text-sm font-bold uppercase tracking-[0.2em] text-tx-navy mb-10" data-id="element-21">
          Certified, Licensed, and Accredited
        </p>
      </div>

      {/* Auto-scrolling marquee with soft fade edges */}
      <div className="group relative w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]" data-id="element-22">
        <motion.ul className="flex w-max items-center gap-x-12 sm:gap-x-16 lg:gap-x-20 group-hover:[animation-play-state:paused]" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 35,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-23">
          {track.map((logo, index) => <li key={`${logo.alt}-${index}`} className="flex shrink-0 items-center justify-center" aria-hidden={index >= logos.length} data-id="element-24">
              <img src={logo.src} alt={index < logos.length ? logo.alt : ''} className="h-14 sm:h-[70px] w-auto object-contain" loading="lazy" data-id="element-25" />
            </li>)}
        </motion.ul>
      </div>
    </section>;
}